import { render } from "./IosCardEn.vue?vue&type=template&id=43b2fb90&scoped=true"
import script from "./IosCardEn.vue?vue&type=script&lang=js"
export * from "./IosCardEn.vue?vue&type=script&lang=js"

import "./IosCardEn.vue?vue&type=style&index=0&id=43b2fb90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b2fb90"]])

export default __exports__